import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/common/PageHero";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { CTASection } from "@/components/common/CTASection";
import { WHY_INDIA, IMAGES } from "@/lib/content";

export default function WhyIndia() {
  const navigate = useNavigate();
  return (
    <>
      <PageHero
        kicker="Why India"
        title="Why India? Why now?"
        subtitle="India offers a rare combination of scale, skill, and cost efficiency — and a fast-growing global capability center ecosystem to build within."
        image={IMAGES.indiaRoad}
      />

      <section className="section-pad" data-testid="why-india-grid">
        <div className="container-px">
          <SectionHeading kicker="The Opportunity" title="What makes India compelling" center />
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {WHY_INDIA.map((p, i) => (
              <Reveal key={p.title} i={i}>
                <div className="h-full rounded-2xl border border-white/8 bg-white/[0.02] p-7 transition-colors hover:border-orange-500/30">
                  <span className="font-mono text-sm text-orange-400">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="mt-3 font-head text-lg font-bold text-white">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-zinc-400">{p.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad border-t border-white/10 bg-[#131316]" data-testid="why-india-cta">
        <div className="container-px">
          <div className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-[#17171A] p-10 sm:p-14">
            <div className="absolute inset-0"><img src={IMAGES.cityDusk} alt="" className="h-full w-full object-cover opacity-20" /><div className="absolute inset-0 bg-gradient-to-r from-[#17171A] to-[#17171A]/50" /></div>
            <div className="relative max-w-xl">
              <h2 className="font-head text-3xl font-bold text-white sm:text-4xl">Explore India with Pixel-Hatch</h2>
              <p className="mt-5 text-zinc-400">We'll help you understand the opportunity in the context of your business — and build a plan that captures it.</p>
              <button onClick={() => navigate("/contact")} className="btn-primary mt-8" data-testid="why-india-explore-cta">
                Explore India <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
